import React from 'react';

import { ADMIN_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs.ts';
import { BulkSpacePermissionsPage } from '@confluence/bulk-permissions/entry-points/BulkPermissions.tsx';
import { BulkAccessManagementPage } from '@confluence/bulk-permissions/entry-points/BulkAccess.tsx';
import { ANALYTICS_SOURCE } from '@confluence/bulk-permissions/entry-points/BulkPermissionsConstants.ts';
import { expVal } from '@confluence/feature-experiments';
import { AdminSecurityPageWrapper } from '@confluence/site-permissions/entry-points/AdminSecurityPageWrapper.ts';
import { useSpaceRoleMode } from '@confluence/space-utils/entry-points/useSpaceRoleMode.ts';

export const BulkSpacePermissionsRoute: {
	(): React.JSX.Element;
	NAVIGATION_PARAMS(): {
		Screen: {
			screenEvent: {
				name: string;
			};
		};
		MainLayout: {
			navView: string;
		};
	};
} = (): React.JSX.Element => {
	const { isRbacEnabled } = useSpaceRoleMode();

	if (!isRbacEnabled) {
		return (
			<AdminSecurityPageWrapper bannerVariant="space">
				<BulkSpacePermissionsPage />
			</AdminSecurityPageWrapper>
		);
	}

	if (expVal('cc_perms_enable_rbac_admin_modernization', 'isEnabled', false)) {
		return (
			<AdminSecurityPageWrapper bannerVariant="space">
				<BulkAccessManagementPage />
			</AdminSecurityPageWrapper>
		);
	}

	return (
		<AdminSecurityPageWrapper bannerVariant="space">
			<BulkAccessManagementPage />
		</AdminSecurityPageWrapper>
	);
};

BulkSpacePermissionsRoute.NAVIGATION_PARAMS = (): {
	Screen: {
		screenEvent: {
			name: string;
		};
	};
	MainLayout: {
		navView: string;
	};
} => ({
	Screen: {
		screenEvent: {
			name: ANALYTICS_SOURCE,
		},
	},
	MainLayout: {
		navView: ADMIN_HOME_ID,
	},
});
